import { render, staticRenderFns } from "./PsPatientBtnNewEventual.vue?vue&type=template&id=a6077290&scoped=true&"
import script from "./PsPatientBtnNewEventual.vue?vue&type=script&lang=js&"
export * from "./PsPatientBtnNewEventual.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientBtnNewEventual.vue?vue&type=style&index=0&id=a6077290&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6077290",
  null
  
)

export default component.exports